import { propTypes as CheckBoxPropTypes } from "lib/formInputs/checkbox/Checkbox";
import { propTypes as DatepickerPropTypes } from "lib/formInputs/datepicker/Datepicker";
import { propTypes as FormInputControlPropTypes } from "lib/formInputs/formInputGroups/FormInputControl";
import { propTypes as FormInputErrorPropTypes } from "lib/formInputs/formInputGroups/FormInputError";
import { propTypes as FormInputGroupPropTypes } from "lib/formInputs/formInputGroups/FormInputGroup";
import { propTypes as FormInputLabelPropTypes } from "lib/formInputs/formInputGroups/FormInputLabel";
import { propTypes as PhoneNumberPropTypes } from "lib/formInputs/phoneNumber/PhoneNumber";
import { propTypes as SelectPropTypes } from "lib/formInputs/select/Select";

export const propTypes = {
  ...CheckBoxPropTypes,
  ...SelectPropTypes,
  ...DatepickerPropTypes,
  ...PhoneNumberPropTypes,
  ...FormInputControlPropTypes,
  ...FormInputErrorPropTypes,
  ...FormInputGroupPropTypes,
  ...FormInputLabelPropTypes,
};
